const selectors = {
  thumbnailsCarouselPrevButton: '.js-thumbnails-carousel-prev-button',
  thumbnailsCarouselNextButton: '.js-thumbnails-carousel-next-button'
};

if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class productGallery extends HTMLElement {
      constructor() {
        super()
        this.mainCarousel = null
        this.thumbnailCarousel = null
        this.nextArrow = null
        this.prevArrow = null
        this.count = parseInt(this.getAttribute('data-media-count'))
        this.mountCarousel()
      }
      connectedCallback() {
        this.moveToPrevThumbSlide = this.moveToPrevThumbSlide.bind(this)
        this.moveToNextThumbSlide = this.moveToNextThumbSlide.bind(this)

        this.thumbnailsCarouselPrevButtonEl = this.querySelector(selectors.thumbnailsCarouselPrevButton)
        this.thumbnailsCarouselNextButtonEl = this.querySelector(selectors.thumbnailsCarouselNextButton)

        if (this.thumbnailsCarouselPrevButtonEl) {
          this.thumbnailsCarouselPrevButtonEl.addEventListener('click', this.moveToPrevThumbSlide)
        }

        if (this.thumbnailsCarouselNextButtonEl) {
          this.thumbnailsCarouselNextButtonEl.addEventListener('click', this.moveToNextThumbSlide)
        }
      }
      disconnectedCallback() {
        if (this.thumbnailsCarouselPrevButtonEl) {
          this.thumbnailsCarouselPrevButtonEl.removeEventListener('click', this.moveToPrevThumbSlide)
        }

        if (this.thumbnailsCarouselNextButtonEl) {
          this.thumbnailsCarouselNextButtonEl.removeEventListener('click', this.moveToNextThumbSlide)
        }
      }
      moveToNextThumbSlide() {
        this.thumbnailCarousel?.go('>')
      }
      moveToPrevThumbSlide() {
        this.thumbnailCarousel?.go('<')
      }
      mountCarousel() {
        var height, focus
        if (this.count < 5) {
          height = 'auto'
          focus = 1
        } else {
          height = 600
          focus = 'center'
        }
        const thumbnailOptions = {
          width: 104,
          height: height,
          direction: 'ttb',
          isNavigation: true,
          fixedWidth: 104,
          gap: 20,
          fixedHeight: 104,
          pagination: false,
          focus: focus,
          arrows: false,
          breakpoints: {
            768: {
              destroy: true
            }
          }
        }
        const mainOptions = {
          type: 'loop',
          arrows: true,
          pagination: false,
          perPage: 1,
          perMove: 1,
          gap: 20,
          easing: 'ease',
          width: '67vw',
          lazyLoad: 'nearby',
          breakpoints: {
            1070: {
              width: '100%',
              gap: 0,
              focus: 'center',
              type: 'loop',
              dragMinThreshold: 10,
              flickPower: 0,
              flickMaxPages: 1,
              perPage: 1,
              perMove: 1,
              drag: true,
              snap: true,
              pagination: true
            }
          }
        }
        this.mainCarousel = new Splide('#main-slider', mainOptions)
        this.thumbnailCarousel = new Splide('#thumbnail-carousel', thumbnailOptions)

        const stripAriaRegionSemantics = splide => {
          const apply = root => {
            if (!root) return

            if (root.getAttribute('role') === 'region') {
              root.removeAttribute('role')
            }

            root.removeAttribute('aria-roledescription')
            root.querySelectorAll('[aria-roledescription]').forEach(el => el.removeAttribute('aria-roledescription'))
          }

          const root = splide?.Components?.Elements?.root || splide?.root

          apply(root)
        }

        stripAriaRegionSemantics(this.mainCarousel)
        stripAriaRegionSemantics(this.thumbnailCarousel)

        this.mainCarousel.sync(this.thumbnailCarousel).mount()
        this.thumbnailCarousel.mount()
        this.mainCarousel.refresh()

        // Ensure we strip after the forced refresh too.
        stripAriaRegionSemantics(this.mainCarousel)
        stripAriaRegionSemantics(this.thumbnailCarousel)
      }
    }
  )
}
